module.exports = __webpack_public_path__ + "static/media/sessionExample.ed53311f.png";